import { customElement } from "lit/decorators.js";
import { MessageFormPage } from "../message-form-page/message-form-page";
import { t } from "../../translations/i18n";

@customElement("create-message-page")
export class CreateMessagePage extends MessageFormPage {
  get mode() {
    return "create" as const;
  }

  get pageTitle() {
    return t("creatorMessages.createTitle");
  }

  get pageSubtitle() {
    return t("creatorMessages.createSubtitle");
  }

  override connectedCallback(): void {
    super.connectedCallback();
    this.formService.reset();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "create-message-page": CreateMessagePage;
  }
}
